export var PanelArrangement;
(function (PanelArrangement) {
    PanelArrangement[PanelArrangement["Solid"] = 0] = "Solid";
    PanelArrangement[PanelArrangement["Columns"] = 1] = "Columns";
    PanelArrangement[PanelArrangement["Checkerboard"] = 2] = "Checkerboard";
    PanelArrangement[PanelArrangement["HorizontalBand"] = 3] = "HorizontalBand";
    PanelArrangement[PanelArrangement["Rows"] = 4] = "Rows";
    PanelArrangement[PanelArrangement["Quarters"] = 5] = "Quarters";
    PanelArrangement[PanelArrangement["HorizontalSplit"] = 6] = "HorizontalSplit";
    PanelArrangement[PanelArrangement["Unknown"] = 7] = "Unknown";
})(PanelArrangement || (PanelArrangement = {}));
//# sourceMappingURL=types.js.map